import { animate, inView, stagger, timeline } from "motion";

const animateSvgLine = (el) => {
  if (el.classList.contains("svg-line-vertical")) {
    el.style.height = 0;
    el.style.opacity = 1;
    animate(el, { height: "100%" }, { duration: 0.6, easing: "linear" });
  }

  if (el.classList.contains("svg-line-horizontal")) {
    el.style.width = 0;
    el.style.opacity = 1;
    animate(el, { width: "100%" }, { duration: 0.6, easing: "linear" });
  }
};

const animateSvgEABFade = (el) => {
  animate(el, { x: ["-5%", 0], opacity: [0, 1] }, { duration: 1, easing: "linear" });
};

const animateSlideReveal = (el) => {
  animate(el, { x: [0, "100%"] }, { duration: 1.2, delay: 0.2, easing: "ease" });
};

const variants = {
  "fade-up": {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  "fade-up-left": {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  "fade-down": {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  "fade-left": {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  "fade-left-slow": {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  "fade-right": {
    opacity: 1,
    transform: "translate3d(0, 0, 0)",
  },
  "fade-in": {
    opacity: 1,
  },
  "scale-in": {
    opacity: 1,
    transform: "scale(1)",
  },
};

const reveal = (group) => {
  if (group.dataset.srGroup === "sequence") {
    const sequence = [];

    group.querySelectorAll(`[data-sr]`).forEach((el) => {
      const variant = variants[el.dataset.sr];

      if (variant && el.style.display !== "none") {
        sequence.push([el, variant, { ease: "ease", duration: 0.8, at: "-0.4" }]);
      }
    });

    inView(
      group,
      () => {
        timeline(sequence).finished.then((animations) => {
          animations?.forEach((animation) => {
            animation.effect?.target?.setAttribute("data-sr-done", true);
          });
        });
      },
      {
        margin: "0px 0px -25% 0px",
      },
    );
  } else {
    for (const [key, opts] of Object.entries(variants)) {
      const els = Array.from(group.querySelectorAll(`[data-sr="${key}"]`));

      let duration = 0.8;

      if (key === "fade-in" || key === "fade-left-slow") {
        duration = 1.5;
      }

      if (els.length) {
        els.forEach((el, index) => {
          const checklists = el.querySelectorAll("[class*=as-check-list]");

          if (checklists.length) {
            let children = [];

            Array.from(el.children).forEach((child) => {
              if (
                ["as-check-list-blue", "as-check-list-green", "as-check-list-orange", "as-check-list-white"].some(
                  (className) => child.classList.contains(className),
                )
              ) {
                const lis = Array.from(child.querySelectorAll("li"));

                children = [...children, ...lis];
              } else {
                children.push(child);
              }
            });

            children.map((child) => child.setAttribute("data-sr", "fade-up"));

            el.removeAttribute("data-sr");
            els.splice(index, 1, ...children);
          }
        });

        const doAnimation = () => {
          animate(els, opts, {
            duration,
            delay: stagger(0.2),
          }).finished.then((animations) => {
            animations?.forEach((animation) => {
              animation.effect?.target?.setAttribute("data-sr-done", true);
            });

            group.setAttribute("data-sr-done", true);
          });
        };

        if (group.dataset.srGroup === "onload") {
          doAnimation();
        } else {
          inView(group, doAnimation, {
            margin: "0px 0px -25% 0px",
          });
        }
      }
    }
  }
};

const handleMutations = (group, mutationList) => {
  for (const mutation of mutationList) {
    if (mutation.type === "childList") {
      reveal(group);
    }
  }
};

export default {
  init: () => {
    document.querySelectorAll(".svg-eab-fade").forEach((el) => {
      const observer = new IntersectionObserver(([e]) => {
        if (e.isIntersecting) {
          setTimeout(() => {
            animateSvgEABFade(el);
          }, 250);

          observer.disconnect();
        }
      });

      observer.observe(el);
    });

    document.querySelectorAll("main [class*=svg-line], footer [class*=svg-line]").forEach((el) => {
      const observer = new IntersectionObserver(
        ([e]) => {
          if (e.isIntersecting) {
            setTimeout(() => {
              animateSvgLine(el);
            }, 250);

            observer.disconnect();
          }
        },
        {
          threshold: 0.1,
        },
      );

      observer.observe(el);
    });

    document.querySelectorAll("[data-slide-reveal]").forEach((el) => {
      const observer = new IntersectionObserver(([e]) => {
        if (e.isIntersecting) {
          animateSlideReveal(el);

          observer.disconnect();
        }
      });

      observer.observe(el);
    });

    document.querySelectorAll("[data-sr-group]").forEach((group) => {
      if (group.closest("[data-disable-animations]")) {
        group.removeAttribute("data-sr-group");
        return;
      }

      if (group.dataset.srGroup !== "trigger") {
        reveal(group);
      }

      if (group.dataset.srGroup === "observe") {
        const observer = new MutationObserver(handleMutations.bind(null, group));

        observer.observe(group, {
          childList: true,
          subtree: true,
        });
      }
    });
  },
  reveal,
};
